export const setLoading = (value: boolean) => {
  return { type: "SET_LOADING", value };
};

export const setLoadingModal = (value: boolean) => {
  return { type: "SET_LOADING_MODAL", value };
};

export const setDrawerDesktop = (value: boolean) => {
  return { type: "SET_DRAWER_DESKTOP", value };
};

export const setDrawerMobile = (value: boolean) => {
  return { type: "SET_DRAWER_MOBILE", value };
};

export const setModalFormOpen = (value: boolean) => {
  return { type: "SET_MODAL_FORM", value };
};

export const setModalVerifyKtpOpen = (value: boolean) => {
  return { type: "SET_MODAL_VERIFY_KTP", value };
};

export const setModalConfirmationOpen = (value: boolean) => {
  return { type: "SET_MODAL_CONFIRMATION", value };
};

export const setModalDescriptionOpen = (value: boolean) => {
  return { type: "SET_MODAL_DESCRIPTION", value };
};
